import { ButtonGroup, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ConfirmationButton } from "../../../../components/ConfirmationButton";
import Loading from "../../../../components/loading";
import { PaginationQueryPackage } from "../../../../models/API/QueryParams/PaginationQueryPackage";
import { ApprovalStatus } from "../../../../models/enums/ApprovalStatus";
import { agreementsApiSlice, useGetAgreementsByServiceIdQuery } from "../../../AgreementApi/redux/agreementsApiSlice";
import { AgreementList } from "../../../AgreementApi/agreementList";
import { DataGridId } from "../../../../components/DatagridWrapper";
import { ServiceResponse } from "../../../../models/Service";

export interface ServiceDeleteContentProps {
  service: ServiceResponse
  setReadyForDelete: (ready: boolean) => void
}

export const ServiceDeleteContent = (props: ServiceDeleteContentProps) => {
  const { t } = useTranslation()

  const activeAgreements = useGetAgreementsByServiceIdQuery({
    pagination: new PaginationQueryPackage(),
    uuid: props.service.uuid,
    requestData: [ApprovalStatus.APPROVED]
  }).data;

  const deleteAgreementTrigger = agreementsApiSlice.useDeleteAgreementMutation()[0];

  if (activeAgreements == undefined)
    return <Loading />

  const serviceHasActiveAgreements: boolean = activeAgreements.length > 0

  if (!serviceHasActiveAgreements) {
    props.setReadyForDelete(true)
    return null
  }

  async function deleteAll() {
    const promises = activeAgreements!.map(async (agreement: any) => deleteAgreementTrigger({ data: agreement }))
    await Promise.all(promises)
  }

  return (
    <Stack spacing={5}>
      {serviceHasActiveAgreements &&
        <ListWithDeleteAllButton
          description={t("The service has attached agreements that need to be terminated in order to delete the service")}
          deleteAllAction={deleteAll}
          deleteAll={t("Delete all agreements")}
          confirmationText={t("Are you sure you wish to delete all agreements associated with this service?", { "numberOfAgreements": activeAgreements?.length })}
        >
          <AgreementList dataGridId={DataGridId.AGREEMENTS_SIMPLE} statusList={[ApprovalStatus.APPROVED]} simpleView={true} agreements={activeAgreements}></AgreementList>
        </ListWithDeleteAllButton>
      }
    </Stack>
  )
}

export const ListWithDeleteAllButton = (props: { description: string, children: JSX.Element, deleteAllAction: () => Promise<void>, deleteAll: string, confirmationText: string }) => {
  const { t } = useTranslation()
  return (
    <Stack spacing={2}>
      <Typography>{props.description}</Typography>
      {props.children}
      <ButtonGroup>
        <ConfirmationButton
          maxWidth="lg"
          action={props.deleteAllAction}
          title={props.deleteAll}
          buttonText={props.deleteAll}>
          <>
            <Typography>{props.confirmationText}</Typography>
            <Typography fontWeight="bold">{t("You will not be able to undo this action")}</Typography>
          </>
        </ConfirmationButton>
      </ButtonGroup>
      <Divider />
    </Stack>
  )
}

